<script>
import BaseButton from '@/components/general/_base-button.vue'
import BaseModal from '@/components/general/_base-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ScheduleExceptionCard',

  components: {
    BaseButton,
    BaseModal,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    clientId: {
      type: Number,
      required: true,
    },
    locationId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    dateLocal: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showConfirmDeleteModal: false,
      isConfirmDeleteLoading: false,
    }
  },

  methods: {
    ...mapActions('client', ['deleteScheduleException']),
    async handleDelete() {
      this.isConfirmDeleteLoading = true
      const { isSuccess } = await this.deleteScheduleException({
        clientId: this.clientId,
        locationId: this.locationId,
        exceptionId: this.id,
      })
      this.showConfirmDeleteModal = false
      this.isConfirmDeleteLoading = false

      if (isSuccess) {
        this.$emit('remove-exception', this.id)
      }
    },
  },
}
</script>

<template>
  <div class="schedule-card mr-4">
    <v-card
      elevation="2"
      class="overflow-hidden rounded-lg d-flex align-end"
      width="350px"
      height="120px"
    >
      <v-img
        :key="img"
        :src="img"
        transition="fade-transition"
        class="bg-img"
        height="100%"
      >
        <template v-slot:placeholder>
          <v-skeleton-loader type="image" class="w-100 h-100" /> </template
      ></v-img>
      <div
        class="p-absolute d-flex align-center justify-center w-100 h-100 pb-6 overlay-bg"
      >
        <BaseButton
          fab
          icon="mdi-pencil"
          color="transparent"
          hover-color="transparent"
          icon-color="white"
          icon-hover-color="primary"
          class="mr-1"
          @click="$emit('edit-exception', id)"
        />
        <BaseButton
          fab
          icon="mdi-delete"
          color="transparent"
          hover-color="transparent"
          icon-color="error"
          icon-hover-color="error darken-1"
          @click="showConfirmDeleteModal = true"
        />
      </div>
      <div
        class="p-relative w-100 white--text secondary px-4 py-1 d-flex justify-space-between align-center remove-border-radius"
      >
        <transition name="fade-cycle-down" mode="out-in">
          <div :key="title">
            <p
              class="text-body-1 font-weight-medium mb-0 ws-nowrap text-capitalize"
            >
              {{ title | truncateText(25, '...') }}
            </p>
          </div>
        </transition>
        <transition name="fade-cycle-down" mode="out-in">
          <div :key="dateLocal">
            <span class="text-body-1 font-weight-medium">{{ dateLocal }}</span>
          </div>
        </transition>
      </div>
    </v-card>
    <BaseModal
      v-model="showConfirmDeleteModal"
      hide-actions
      hide-header-divider
      width="400px"
    >
      <template v-slot:header>
        <div class="text-h5 mx-auto mb-2 mt-1">{{
          $t('client.schedule.exception.deleteModal.title')
        }}</div>
      </template>
      <template v-slot>
        <div class="text-body-1 text-grey px-10 text-center">
          {{ $t('client.schedule.exception.deleteModal.message') }}
        </div>
        <div class="d-flex justify-center align-center mt-6">
          <BaseButton
            class="mr-4"
            secondary
            @click="showConfirmDeleteModal = false"
          >
            {{ $t('general.cancel') }}
          </BaseButton>
          <BaseButton
            color="error"
            hover-color="error darken-1"
            :loading="isConfirmDeleteLoading"
            @click="handleDelete"
            >{{ $t('general.delete') }}</BaseButton
          >
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vue-transitions.scss';

.schedule-card {
  display: inline-block;
}

.schedule-card:last-child {
  margin-right: 0;
}

.remove-border-radius {
  border-radius: 0 0 0 0 !important;
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-bg {
  cursor: pointer !important;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 1;
  }
}
</style>
